<script setup>
import { ref } from 'vue'
import DataTable from './datatable/DataTable.vue'
import { Button } from "@/components/ui/button"
import { LockOpen } from "lucide-vue-next";
import { get_data_attr } from '@/utils/globals'
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const specsInfo = get_data_attr("specs");
const specsTypesInfo = get_data_attr("spectypes");
const rkIconUrl = '/path/to/logo.png'; // define your logo

const selectedId = ref(null)
const selectedRoleId = ref(null)

function setSelectedId(rowid) {
	selectedRoleId.value = rowid;
}
</script>

<template>
	
<div class="flex h-screen w-full">
  <div class="flex w-2/3 p-4 gap-4">
	 <div class="sflex-1">
       <DataTable label="view.roles"
	              :logo="rkIconUrl" endpoint="roles"
			       :columns="specsInfo['roles']"
				   :enableDetail="false">
		 <template #logo><LockOpen /></template>
	     <template #extraactions="{row}">
		   <Button :id="'rolerights-' + row.id"
		     :title="t('view.btn_rights')" 
		     size="icon" 
		     variant="ghost" 
		     class="text-green-600 hover:bg-blue-50" 
		     @click="() => setSelectedId(row.id)"
		   >
		     <LockOpen class="w-4 h-4" />
		   </Button>
	     </template>
	   </DataTable>
     </div>
     <div class="flex-1">
	   <DataTable label="view.rights"
	             :logo="rkIconUrl" :endpoint="'rights/' + selectedRoleId"
			     :columns="specsInfo['right']"
				 :enableAdd="false"
				 :enableDetail="false"
				 :enableDelete="false">
	   </DataTable>
     </div>
   </div>
</div>
</template>
